// 自定义组件的数据检查, 如果数据有问题，设置invalid=true,由于logicflow的限制，所有的属性必须添加到properties里面
export default {
    // 关联关系检查
    relationValid(edge, data, multi) {
        // 没有data时，是从drawer来的
        if (!data) {
            // 只有多条件时才进行验证
            return multi? this.checkRelationData2(edge): "";
        }
        // 有data时，找到parent, 找到brother
        // 当前这个关联关系，是否是标准的数据
        let nodeIdFrom = edge.properties.parentId;
        // 这个节点是否有多个结果节点
        let relations = data.relations;
        let relationBrother = [];
        for (let i = 0; i < relations.length; i++) {
            if (nodeIdFrom === relations[i].parentId) {
                relationBrother.push(relations[i]);
            }
        }
        for (let i = 0; i < data.nodes.length; i++) {
            if (data.nodes[i].id === nodeIdFrom) {
                edge.parentNode = data.nodes[i];
            }
        }
        /**
         * 需要校验条件的情形，与 LogicFlow.edgeClick 里 multi 的判定保持一致：
         *   1. 上级有多个出线（真正的多分支）
         *   2. 上级是条件判断节点——它的每条出线本身就是一个分支，
         *      即使只连了一条也要配条件，否则条件不覆盖时流程会卡死
         */
        const parentType = edge.parentNode ? edge.parentNode.nodeType : "";
        if (relationBrother.length < 2 && parentType !== "condition") {
            return "";
        }
        this.checkRelationData2(edge);
    },
    // 审批节点数据检查
    checkNodeValid(node, data) {
        // 当设置invalid时，将在页面显示异常标记，当返回message时，在drawer的配置页面不能进行保存
        let params = node.properties.businessParams? JSON.parse(node.properties.businessParams): {};
        // 如果没有选择签署方式，不能保存
        if (!params.checkType) {
            node.properties.invalid = true;
            return "请选择签署方式";
        }
        if (params.checkType === 1 || params.checkType === 2) {
            if (!params.employeeType) {
                node.properties.invalid = true;
                return "请指定签署人员类型"
            }
            if (params.employeeType === 1 && !params.employeeRange) {
                node.properties.invalid = true;
                return "请选择签署人员";
            }
        }
        // 当前节点是否被使用
        this.nodeHasRelation(node, data);
        return "";
    },
    // 业务节点数据检查：必须选定一个业务节点，否则引擎不知道回调哪个接口
    businessNodeValid(node, data) {
        let params = node.properties.businessParams ? JSON.parse(node.properties.businessParams) : {};
        if (!params.nodeId) {
            node.properties.invalid = true;
            return "请选择业务节点";
        }
        this.nodeHasRelation(node, data);
        return "";
    },
    // 条件分支节点是否有问题
    diamondNodeValid(node, data) {
        this.nodeHasRelation(node, data);
        this.conditionHasDefault(node, data);
    },
    /**
     * 条件分支必须有一个 default 兜底分支。
     * 条件表达式不覆盖任何分支时流程会卡死，因此这里强制校验：
     * 该节点的出线中至少要有一条不设条件（即 default）。
     */
    conditionHasDefault(node, data) {
        if (!data || !data.edges) {
            return "";
        }
        let id = node.properties.id;
        let outEdges = [];
        for (let i = 0; i < data.edges.length; i++) {
            if (data.edges[i].sourceNodeId === id) {
                outEdges.push(data.edges[i]);
            }
        }
        if (outEdges.length === 0) {
            return "";
        }
        // 有任一出线的条件列表为空，即视为 default 分支
        for (let i = 0; i < outEdges.length; i++) {
            let properties = outEdges[i].properties || {};
            let conditionList = properties.conditionList || [];
            if (conditionList.length === 0) {
                return "";
            }
        }
        node.properties.invalid = true;
        return "条件分支必须配置一个默认分支(default)";
    },
    // 节点是否有引用，即其它节点和当前节点进行关联
    nodeHasRelation(node, data) {
        // 如果data存在，需要检查节点元素和relation的关系，审批节点，必须有来源，有去处。
        // relations 可能缺失（调用方传的是 LogicFlow 的 edges 结构），
        // 此时无从判断关联关系，直接跳过而不是抛异常中断整个渲染。
        if (!data || !data.relations) {
            return "";
        }
        let relations = data.relations;
        let id = node.properties.id;
        let hasFrom = false, hasTo = false;
        for (let i = 0; i < relations.length; i++) {
            if (relations[i].nodeId === id) {
                hasTo = true;
            } else if (relations[i].parentId === id) {
                hasFrom = true;
            }
        }
        if (!hasFrom || !hasTo) {
            node.properties.invalid = true;
        }
    },
    checkRelationData2(edge) {
        let relation = edge.properties;
        // parentNode 可能拿不到（节点被删等），此时无从判断规则，直接跳过校验
        if (!edge.parentNode) {
            return "";
        }
        if (edge.parentNode.nodeType === "approve" && !relation.checkType) {
            edge.properties.invalid = true;
            return "审批条件未设置审批结果";
        }
        // 如果条件没有设置分支
        // if (!relation.conditionType) {
        //     edge.properties.invalid = true;
        //     return "审批条件未设置条件分支";
        // }
        // 如果有分支，分支是否标准
        this.checkRelationData(edge, relation.conditionList || []);
    },
    /**
     * 条件设置是否有问题。
     * 注意 itemType 标记的是「这一项是条件还是分组」，与字段类型 fieldType 无关。
     */
    checkRelationData(edge, conditionList) {
        for (let i = 0; i < conditionList.length; i++) {
            // 如果是条件分组
            if (conditionList[i].itemType === 2) {
                if (!conditionList[i].conditionList || conditionList[i].conditionList.length === 0) {
                    edge.properties.invalid = true;
                    return "条件分组内未添加条件";
                } else {
                    // 验证下级是否满足
                    let mesg = this.checkRelationData(edge, conditionList[i].conditionList);
                    if (mesg) {
                        return mesg;
                    }
                }
            } else {
                // 是条件项：字段、判断规则、取值三者都必须有
                if (!conditionList[i].fieldName || !conditionList[i].judgeType || !conditionList[i].fieldValue) {
                    edge.properties.invalid = true;
                    return "条件分支未设置条件";
                }
            }
        }
    },
}